import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { productSettingsAPI } from '../services/api';
import './Users.css';

const ProductSettings = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [productExpiryDays, setProductExpiryDays] = useState('30');
  const [auctionsEnabled, setAuctionsEnabled] = useState(true);

  const loadSettings = async () => {
    setLoading(true);
    try {
      const response = await productSettingsAPI.get();
      setProductExpiryDays(String(response.data?.product_expiry_days ?? 30));
      setAuctionsEnabled(response.data?.auctions_enabled !== false);
    } catch (error) {
      toast.error('Error loading product settings: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await productSettingsAPI.update({
        product_expiry_days: parseInt(productExpiryDays, 10),
        auctions_enabled: auctionsEnabled,
      });
      toast.success('Settings updated');
      window.dispatchEvent(new CustomEvent('exglam-settings-changed'));
    } catch (error) {
      toast.error('Error saving settings: ' + (error.response?.data?.message || error.message));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loading">Loading product settings...</div>;

  return (
    <div className="users-container">
      <div className="table-container" style={{ padding: 20, maxWidth: 520 }}>
        <h3 style={{ marginBottom: 16 }}>Product expiration</h3>
        <form onSubmit={submit}>
          <div className="form-group">
            <label>Expiration duration (days)</label>
            <input
              type="number"
              min="1"
              max="3650"
              required
              value={productExpiryDays}
              onChange={(e) => setProductExpiryDays(e.target.value)}
            />
          </div>
          <p style={{ marginBottom: 24, color: '#666' }}>
            Approved products older than this duration will be hidden from the app.
          </p>

          <h3 style={{ marginBottom: 12 }}>Live auctions</h3>
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={auctionsEnabled}
                onChange={(e) => setAuctionsEnabled(e.target.checked)}
              />{' '}
              Show auction section in admin panel and mobile app
            </label>
          </div>
          <p style={{ marginBottom: 16, color: '#666' }}>
            When disabled, Live Auctions menu items and the app Auction tab are hidden. API auction
            endpoints return empty or not found.
          </p>

          <div className="form-actions">
            <button className="btn btn-primary" type="submit" disabled={saving}>
              {saving ? 'Saving...' : 'Save settings'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProductSettings;
